/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/person_shield_medium'
export default icon
